export default {"src":"/_next/static/media/mindscape.7b5d8ae4.svg","height":59,"width":172};